var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSplashtop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Splashtop"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Splashtop",
    clipPath: "url(#clip-Splashtop)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "data-transfer_10781555",
    transform: "translate(-11.5 -12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_351",
    "data-name": "Path 351",
    d: "M18.463,49.845H30.744v4.511h-4.01a1.754,1.754,0,0,0,0,3.509H50.293a1.754,1.754,0,1,0,0-3.509h-4.01V49.845H58.563a5.294,5.294,0,0,0,5.263-5.263V17.263A5.294,5.294,0,0,0,58.563,12h-40.1A5.294,5.294,0,0,0,13.2,17.263V44.331A5.352,5.352,0,0,0,18.463,49.845Zm16.04,0h8.271v4.511H34.5Z",
    transform: "translate(1.054)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_352",
    "data-name": "Path 352",
    d: "M75.963,33.7h-40.1A5.294,5.294,0,0,0,30.6,38.963V66.031a5.294,5.294,0,0,0,5.263,5.263H48.144v4.511h-4.01a1.754,1.754,0,1,0,0,3.509H67.693a1.754,1.754,0,1,0,0-3.509h-4.01V71.294H75.963a5.294,5.294,0,0,0,5.263-5.263V39.214A5.352,5.352,0,0,0,75.963,33.7ZM59.923,76.056H51.653V71.545h8.271Z",
    transform: "translate(27.263 32.686)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_353",
    "data-name": "Path 353",
    d: "M52.7,19.662V16.654A1.713,1.713,0,0,0,50.946,14.9a1.507,1.507,0,0,0-1,.251L35.658,24.674a1.944,1.944,0,0,0-.5,2.506l.5.5,14.286,9.524a1.944,1.944,0,0,0,2.506-.5,1.507,1.507,0,0,0,.251-1V32.694A22.362,22.362,0,0,1,72.5,49.988C72.249,51.993,69.493,55.5,73,56a2.537,2.537,0,0,0,1.754-1A25.252,25.252,0,0,0,60.721,21.667,22.239,22.239,0,0,0,52.7,19.662Z",
    transform: "translate(33.734 4.368)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_354",
    "data-name": "Path 354",
    d: "M39.066,53.051a1.944,1.944,0,0,0-2.506.5c-.251.251-.251.5-.251,1v3.008a22.362,22.362,0,0,1-19.8-17.293c0-2.005,2.757-4.762.251-6.015-1-.251-2.005,0-2.256,1A26.209,26.209,0,0,0,12.5,45.031,25.7,25.7,0,0,0,36.31,70.6V73.6a1.713,1.713,0,0,0,1.754,1.754h0a1.507,1.507,0,0,0,1-.251l14.286-9.524a1.944,1.944,0,0,0,.5-2.506l-.5-.5Z",
    transform: "translate(0 33.385)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashtop);
export default __webpack_public_path__ + "static/media/splashtop.864a7f732c117aee7a26a866c9884ba7.svg";
export { ForwardRef as ReactComponent };